import { render, staticRenderFns } from "./CartCategory.vue?vue&type=template&id=33dbbc8b"
import script from "./CartCategory.vue?vue&type=script&lang=ts"
export * from "./CartCategory.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports